export const abbreviateName = (name: string) => {
  const nameParts = name.trim().split(/\s+/)
  if (nameParts.length < 2) return nameParts[0].charAt(0).toUpperCase()

  const firstInitial = nameParts[0].charAt(0).toUpperCase()
  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase()

  return firstInitial + lastInitial
}
